// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
/* SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>

SPDX-License-Identifier: AGPL-3.0-only
*/

/* Use the font in your CSS */
body {
    font-family: 'Roboto', sans-serif;
}
/*remove the tailwind base resets and add them as css */
*{
  margin: 0; 
}
ol,
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
a {
  color: inherit;
  text-decoration: inherit;
}
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block;
  vertical-align: middle;
}
img,
video {
  max-width: 100%;
  height: auto;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}
body {
  margin: 0;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.MuiScopedCssBaseline-root {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.RaSidebar-fixed .MuiList-root {
  overflow-y: auto !important;
  padding-bottom: 0 !important;
}

button.RaFilterFormInput-hideButton {
  margin-bottom: 21px !important;
}

.list-actions {
  display: flex;
}

.list-actions .MuiButtonBase-root {
    color: #0F054C;
    text-align: center !important;
    font-size: 14px !important;
    font-style: normal !important;
    font-weight: 500 !important;
    line-height: normal !important;
    letter-spacing: normal !important;
    text-transform: uppercase !important;
    border-radius: 0px !important;
    padding: 6px 12px !important;
    height: 35px !important;
    background-color: #fff;
    border-top: 1px solid #0F054C !important;
    border-bottom: 1px solid #0F054C !important;
    border-left: 1px solid #0F054C !important;
    border-right: none;
  }

.list-actions .MuiButtonBase-root:hover {
      box-shadow: none;
      border-top: 1px solid #0F054C !important;
      border-bottom: 1px solid #0F054C !important;
      border-left: 1px solid #0F054C !important;
      border-right: none;
    }

.list-actions .MuiToolbar-root {
    display: flex;
    gap: 0;
  }

.list-actions .MuiToolbar-root .MuiButtonBase-root:last-child {
        border-right: 1px solid #0F054C !important;
      }

.list-actions .MuiButtonBase-root:last-child {
      border-right: 1px solid #0F054C !important;
    }

.iti--inline-dropdown {
  width: 100%;
}

.iti__tel-input {
  width: 100%;
  height: 56px;
  font-size: 16px;
}

.iti__search-input {
  height: 34px;
  width: 100%;
  padding-left: 8px;
}

.iti--inline-dropdown .iti__country-list {
  max-height: 160px;
}

.react-js-cron-custom-select-dropdown, .react-js-cron-select-dropdown-period, .react-js-cron-custom-select-dropdown-minutes-large{
	z-index: 9999999999999;
}

@media print {

   html, body, .dashboard{
        width: 100% !important;
        height: 100%; 
        margin: 0;
        padding: 0;
        overflow: visible !important;
    }

    body {
        overflow: visible !important;
        height: auto !important;
    }

    .print-hidden{
      display: none !important;
    }

    .dashboard{
      transform: scale(0.618);
      transform-origin: top left;
    }

    .dashboard-container{
      transform: scale(0.618);
      display: flex !important;
      flex-direction: row !important;
      flex-wrap: nowrap !important;
      justify-content: flex-start !important;
      gap: 20px !important;
    }

    @page {
      size: auto;
      margin: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;;CAIC;;AAED,6BAA6B;AAC7B;IACI,iCAAiC;AACrC;AACA,uDAAuD;AACvD;EACE,SAAS;AACX;AACA;;EAEE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,cAAc;EACd,wBAAwB;AAC1B;AACA;;;;;;;;EAQE,cAAc;EACd,sBAAsB;AACxB;AACA;;EAEE,eAAe;EACf,YAAY;AACd;AACA;;;;;;EAME,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,2DAA2D;EAC3D,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,wBAAgC;EAChC,2BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;AA6Cf;;AA3CE;IACE,cAAc;IACd,6BAA6B;IAC7B,0BAA0B;IAC1B,6BAA6B;IAC7B,2BAA2B;IAC3B,8BAA8B;IAC9B,iCAAiC;IACjC,oCAAoC;IACpC,6BAA6B;IAC7B,4BAA4B;IAC5B,uBAAuB;IACvB,sBAAsB;IACtB,wCAAwC;IACxC,2CAA2C;IAC3C,yCAAyC;IACzC,kBAAkB;EASpB;;AAPE;MACE,gBAAgB;MAChB,wCAAwC;MACxC,2CAA2C;MAC3C,yCAAyC;MACzC,kBAAkB;IACpB;;AAGF;IACE,aAAa;IACb,MAAM;EAOR;;AAJI;QACE,0CAA0C;MAC5C;;AAKF;MACE,0CAA0C;IAC5C;;AAIJ;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;;GAEG;QACK,sBAAsB;QACtB,YAAY;QACZ,SAAS;QACT,UAAU;QACV,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;QAC5B,uBAAuB;IAC3B;;IAEA;MACE,wBAAwB;IAC1B;;IAEA;MACE,uBAAuB;MACvB,0BAA0B;IAC5B;;IAEA;MACE,uBAAuB;MACvB,wBAAwB;MACxB,8BAA8B;MAC9B,4BAA4B;MAC5B,sCAAsC;MACtC,oBAAoB;IACtB;;IAEA;MACE,UAAU;MACV,SAAS;IACX;AACJ","sourcesContent":["/*\n/* SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>\n\nSPDX-License-Identifier: AGPL-3.0-only\n*/\n\n/* Use the font in your CSS */\nbody {\n    font-family: 'Roboto', sans-serif;\n}\n/*remove the tailwind base resets and add them as css */\n*{\n  margin: 0; \n}\nol,\nul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\na {\n  color: inherit;\n  text-decoration: inherit;\n}\nimg,\nsvg,\nvideo,\ncanvas,\naudio,\niframe,\nembed,\nobject {\n  display: block;\n  vertical-align: middle;\n}\nimg,\nvideo {\n  max-width: 100%;\n  height: auto;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-size: inherit;\n  font-weight: inherit;\n}\nbody {\n  margin: 0;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.MuiScopedCssBaseline-root {\n  margin-block-start: 0 !important;\n  margin-block-end: 0 !important;\n}\n\n.RaSidebar-fixed .MuiList-root {\n  overflow-y: auto !important;\n  padding-bottom: 0 !important;\n}\n\nbutton.RaFilterFormInput-hideButton {\n  margin-bottom: 21px !important;\n}\n\n.list-actions {\n  display: flex;\n\n  .MuiButtonBase-root {\n    color: #0F054C;\n    text-align: center !important;\n    font-size: 14px !important;\n    font-style: normal !important;\n    font-weight: 500 !important;\n    line-height: normal !important;\n    letter-spacing: normal !important;\n    text-transform: uppercase !important;\n    border-radius: 0px !important;\n    padding: 6px 12px !important;\n    height: 35px !important;\n    background-color: #fff;\n    border-top: 1px solid #0F054C !important;\n    border-bottom: 1px solid #0F054C !important;\n    border-left: 1px solid #0F054C !important;\n    border-right: none;\n\n    &:hover {\n      box-shadow: none;\n      border-top: 1px solid #0F054C !important;\n      border-bottom: 1px solid #0F054C !important;\n      border-left: 1px solid #0F054C !important;\n      border-right: none;\n    }\n  }\n\n  .MuiToolbar-root {\n    display: flex;\n    gap: 0;\n\n    .MuiButtonBase-root {\n      &:last-child {\n        border-right: 1px solid #0F054C !important;\n      }\n    }\n  }\n\n  .MuiButtonBase-root {\n    &:last-child {\n      border-right: 1px solid #0F054C !important;\n    }\n  }\n}\n\n.iti--inline-dropdown {\n  width: 100%;\n}\n\n.iti__tel-input {\n  width: 100%;\n  height: 56px;\n  font-size: 16px;\n}\n\n.iti__search-input {\n  height: 34px;\n  width: 100%;\n  padding-inline-start: 8px;\n}\n\n.iti--inline-dropdown .iti__country-list {\n  max-height: 160px;\n}\n\n.react-js-cron-custom-select-dropdown, .react-js-cron-select-dropdown-period, .react-js-cron-custom-select-dropdown-minutes-large{\n\tz-index: 9999999999999;\n}\n\n@media print {\n\n   html, body, .dashboard{\n        width: 100% !important;\n        height: 100%; \n        margin: 0;\n        padding: 0;\n        overflow: visible !important;\n    }\n\n    body {\n        overflow: visible !important;\n        height: auto !important;\n    }\n\n    .print-hidden{\n      display: none !important;\n    }\n\n    .dashboard{\n      transform: scale(0.618);\n      transform-origin: top left;\n    }\n\n    .dashboard-container{\n      transform: scale(0.618);\n      display: flex !important;\n      flex-direction: row !important;\n      flex-wrap: nowrap !important;\n      justify-content: flex-start !important;\n      gap: 20px !important;\n    }\n\n    @page {\n      size: auto;\n      margin: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
